import { LOCAL_ENV } from '../../../../config/config';

import ICON_SYSTEM_HOME from '@home/assets/img/urlCollection/system-dbh.png';
import ICON_SYSTEM_INTELLIGENCE from '@home/assets/img/urlCollection/system-dbi.png';
import ICON_SYSTEM_DASHBOARD from '@home/assets/img/urlCollection/system-dbd.png';
import ICON_SYSTEM_OPINIONS from '@home/assets/img/urlCollection/system-dbo.png';
import ICON_SYSTEM_MARKETING from '@home/assets/img/urlCollection/system-dbom.png';
import ICON_SYSTEM_STUDIO_HUB from '@home/assets/img/urlCollection/system-dbs.png';
import ICON_SYSTEM_BENCHMARK from '@home/assets/img/urlCollection/system-dbb.png';
import ICON_SYSTEM_USER_CENTER from '@home/assets/img/urlCollection/system-dbu.png';
import ICON_SYSTEM_DATALAB from '@home/assets/img/urlCollection/system-dbdl.png';
import ICON_SYSTEM_HOME_AVATAR from '@home/assets/img/urlCollection/system-dbh-avatar.png';
import ICON_SYSTEM_INTELLIGENCE_AVATAR from '@home/assets/img/urlCollection/system-dbi-avatar.png';
import ICON_SYSTEM_DASHBOARD_AVATAR from '@home/assets/img/urlCollection/system-dbd-avatar.png';
import ICON_SYSTEM_OPINIONS_AVATAR from '@home/assets/img/urlCollection/system-dbo-avatar.png';
import ICON_SYSTEM_MARKETING_AVATAR from '@home/assets/img/urlCollection/system-dbom-avatar.png';
import ICON_SYSTEM_STUDIO_HUB_AVATAR from '@home/assets/img/urlCollection/system-dbs-avatar.png';
import ICON_SYSTEM_BENCHMARK_AVATAR from '@home/assets/img/urlCollection/system-dbb-avatar.png';
import ICON_SYSTEM_USER_CENTER_AVATAR from '@home/assets/img/urlCollection/system.dbu-avatar.png';
import ICON_SYSTEM_DATALAB_AVATAR from '@home/assets/img/urlCollection/system-dbdl-avatar.png';

export const LANGUAGE_EN = 'en-US';
export const LANGUAGE_CN = 'zh-CN';

export const DBSystemCode = {
  Home: 'home',
  Intelligence: 'intelligence',
  Dashboard: 'dashboard',
  Opinions: 'opinions',
  Marketing: 'marketing',
  Globalpedia: 'globalpedia',
  Mgmt: 'mgmt',
  StudioHub: 'studioHub',
  Benchmark: 'benchmark',
  UserCenter: 'userCenter',
  Datalab: 'datalab',
  Ai: 'ai',
} as const;

export const DBSystemNameI18nKeyMap = {
  [DBSystemCode.Home]: 'dbh_home',
  [DBSystemCode.Intelligence]: 'dbh_intelligence',
  [DBSystemCode.Dashboard]: 'dbh_dashboard',
  [DBSystemCode.Opinions]: 'dbh_opinion',
  [DBSystemCode.Marketing]: 'dbh_marketing',
  [DBSystemCode.Globalpedia]: 'dbh_gpop',
  [DBSystemCode.Mgmt]: 'dbh_mgmt',
  [DBSystemCode.StudioHub]: 'dbh_studio_hub',
  [DBSystemCode.Benchmark]: 'dbh_benchmark',
  [DBSystemCode.UserCenter]: 'dbh_user_center',
  [DBSystemCode.Datalab]: 'dbh_datalab',
  [DBSystemCode.Ai]: 'dbh_ai',
};

export const DBSystemIconMap = {
  [DBSystemCode.Home]: ICON_SYSTEM_HOME,
  [DBSystemCode.Intelligence]: ICON_SYSTEM_INTELLIGENCE,
  [DBSystemCode.Dashboard]: ICON_SYSTEM_DASHBOARD,
  [DBSystemCode.Opinions]: ICON_SYSTEM_OPINIONS,
  [DBSystemCode.Marketing]: ICON_SYSTEM_MARKETING,
  // TODO: 补充Globalpedia图标
  [DBSystemCode.Globalpedia]: ICON_SYSTEM_MARKETING,
  // TODO: 补充Mgmt图标
  [DBSystemCode.Mgmt]: ICON_SYSTEM_MARKETING,
  [DBSystemCode.StudioHub]: ICON_SYSTEM_STUDIO_HUB,
  [DBSystemCode.Benchmark]: ICON_SYSTEM_BENCHMARK,
  [DBSystemCode.UserCenter]: ICON_SYSTEM_USER_CENTER,
  [DBSystemCode.Datalab]: ICON_SYSTEM_DATALAB,
};

export const DBSystemAvatarIconMap = {
  [DBSystemCode.Home]: ICON_SYSTEM_HOME_AVATAR,
  [DBSystemCode.Intelligence]: ICON_SYSTEM_INTELLIGENCE_AVATAR,
  [DBSystemCode.Dashboard]: ICON_SYSTEM_DASHBOARD_AVATAR,
  [DBSystemCode.Opinions]: ICON_SYSTEM_OPINIONS_AVATAR,
  [DBSystemCode.Marketing]: ICON_SYSTEM_MARKETING_AVATAR,
  // TODO: 补充Globalpedia图标
  [DBSystemCode.Globalpedia]: ICON_SYSTEM_MARKETING_AVATAR,
  // TODO: 补充Mgmt图标
  [DBSystemCode.Mgmt]: ICON_SYSTEM_MARKETING_AVATAR,
  [DBSystemCode.StudioHub]: ICON_SYSTEM_STUDIO_HUB_AVATAR,
  [DBSystemCode.Benchmark]: ICON_SYSTEM_BENCHMARK_AVATAR,
  [DBSystemCode.UserCenter]: ICON_SYSTEM_USER_CENTER_AVATAR,
  [DBSystemCode.Datalab]: ICON_SYSTEM_DATALAB_AVATAR,
};

export const LOGIN_14_DAYS_KEY = '__db_14days_login__';
export const SYSTEM_THEME_KEY = '__db_theme__';
export const LAST_LOGIN_DATE_KEY = '__db_last_login_date__';

export const SYSTEM_THEME_LIGHT = 'Light';
export const SYSTEM_THEME_DARK = 'Dark';

export const SYSTEM_THEME_DARK_CLASS = 'c-theme-dark';
export const AGENT_ROBOT_EXPEND_STATE = '__dba_agent_robot_expend__';

const hostname = window.location.hostname;
const ACCESS_LINK_INTLGAME = 'https://appauth.intlgame.com/workbench/initprocess?workSpaceUUId=1';
const ACCESS_LINK_WOA = 'https://appauth.woa.com/workbench/initprocess?workSpaceUUId=1';

export const IS_WOA = hostname.endsWith('.woa.com');
export const IS_INTLGAME = hostname.endsWith('.intlgame.com');
export const IS_GLOBAL = hostname.startsWith('databrain-global') || hostname.startsWith('databrain-mobile') || window.location.search.includes('env=global');
export const IS_INTLGAME_AND_NOT_TEST = ['databrain.intlgame.com', 'databrain-pre.intlgame.com'].includes(hostname);

// 检测是否为移动端设备
// export const IS_DEVICE_MOBILE = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
export const IS_DEVICE_MOBILE = hostname.endsWith('databrain-mobile.intlgame.com');

// 移动端谷歌登录回调地址
export const CALLBACK_URL = `${window.location.origin}/v2/login/thirdPartyLogin`;

export const ACCESS_LINK = IS_WOA ? ACCESS_LINK_WOA : ACCESS_LINK_INTLGAME;

export const ENV = (function (hostname) {
  // 正式环境
  if (['databrain.woa.com', 'databrain.intlgame.com', 'databrain-global.intlgame.com', 'databrain-mobile.intlgame.com'].indexOf(hostname) > -1) {
    return 'pro';
  }

  // 预发布环境
  if (['databrain-pre.woa.com', 'databrain-pre.intlgame.com', 'databrain-global-pre.intlgame.com'].indexOf(hostname) > -1) {
    return 'pre';
  }

  // 测试环境  databrain-test.intlgame.com， databrain-test2.intlgame.com
  if (hostname.startsWith('databrain-test')) {
    return 'test';
  }

  // dev环境  databrain-dev.intlgame.com
  if (hostname.startsWith('databrain-dev')) {
    return 'test';
  }

  // 本地环境
  return LOCAL_ENV || 'dev';
})(hostname);

// 是否启用新系统
export const SYSTEM_INFO = {
  home: {
    dev: true,
    test: true,
    pre: true,
    pro: true
  },
  dashboard: {
    dev: true,
    test: true,
    pre: true,
    pro: true
  },
  datalab: {
    dev: true,
    test: true,
    pre: true,
    pro: true
  },
  managementdashboard: {
    dev: true,
    test: true,
    pre: true,
    pro: true
  },
  intelligence: {
    dev: true,
    test: true,
    pre: true,
    pro: true
  },// 打开时请注意首页跳转问题
  opinion: {
    dev: true,
    test: true,
    pre: true,
    pro: true
  },
  globalpedia: {
    dev: true,
    test: true,
    pre: true,
    pro: true
  },
  aigc: {
    dev: true,
    test: true,
    pre: true,
    pro: true
  },
  chatgpt: {
    dev: true,
    test: true,
    pre: true,
    pro: true
  },
  studio: {
    dev: true,
    test: true,
    pre: true,
    pro: true
  },
  benchmark: {
    dev: true,
    test: true,
    pre: true,
    pro: true
  }
} as any;

export const TABLE_CELL_PADDING_LEFT = 20;
export const TABLE_CELL_PADDING_RIGHT = 20;

// 加密信息的公钥
export const PUBLIC_KEY = ((ENV) => {
  // 预发布，正式使用另外的公钥
  if( ['pre', 'pro'].includes(ENV)){
    return '-----BEGIN PUBLIC KEY-----MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC9pfReg/aGPcNaZ2iXI7vVMN0ht3RzIeqRv9r432VNcyIPVa2W4pEvzuAUfPgG5F6gblbdGwWfZDxvYhx6FFcvAsO4KLnsgWCkvkVLyUQMMfNssbiL1s7P9auivfW6naMx6db1nUN2ndRKC4OxUyqSO8yRQUo7UfCw1HyMOVtGnwIDAQAB-----END PUBLIC KEY-----';
  }
  return '-----BEGIN PUBLIC KEY-----MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCS03yV8l5T4eyXemXW835KxI3LnFxtj/nGzYFevTiQAuCjliQnV4wLtKzhPdMl0NqDEcGt5yjzyf3YjTp4sBu4R1+oJKiUX4sTrgVW9Fha+/1q6VXTp08cHCG9MV7mWMU0+d38uqcnK/ZNZXFkup2+fyqb0HXsUqmADR74z6t2nQIDAQAB-----END PUBLIC KEY-----';
})(ENV);
